import React from "react"
import { useTranslation } from "react-i18next"
import { Box, styled } from "@mui/material"

import Providers from "components/ui/Providers"
import {
  PS_SIGN_STEP_SMART_ID,
  PS_SIGN_STEP_MOBILE_ID,
  PS_SIGN_STEP_ID_CARD,
} from "config"

type Props = {
  onChoose: (step: number) => void
}

const ProvidersListComponent = ({ onChoose }: Props) => {
  const { t } = useTranslation()

  const PROVIDERS = [
    {
      path: PS_SIGN_STEP_SMART_ID.toString(),
      title: t("providers.smart_id.title"),
    },
    {
      path: PS_SIGN_STEP_MOBILE_ID.toString(),
      title: t("providers.mobile_id.title"),
    },
    {
      path: PS_SIGN_STEP_ID_CARD.toString(),
      title: t("providers.id_card.title"),
    },
  ]

  const handleClick = (path: string) => {
    onChoose(parseInt(path))
  }

  return (
    <Container>
      <Providers
        light={false}
        disabled={false}
        items={PROVIDERS}
        onClick={(path) => handleClick(path)}
      />
    </Container>
  )
}

export default ProvidersListComponent

export const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  [theme.breakpoints.up("lg")]: {
    backgroundColor: "transparent",
    minWidth: "530px",
    margin: "0 auto",
    width: "562px",
  },
  [theme.breakpoints.down("lg")]: {
    backgroundColor: theme.palette.common.white,
    borderRadius: "36px",
    padding: "8px 16px 36px 16px",
    margin: "24px auto",
    width: "70%",
  },
  [theme.breakpoints.down("md")]: {
    width: "85%",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}))
